//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

((() => {
    angular.module('curalate').config(['$routeProvider', '$locationProvider',
        ($routeProvider, $locationProvider) => {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
            }).hashPrefix('!');
            $routeProvider.
            when('/v1/experiences/', {
                template: '<experiences-list>',
            }).
            when('/v1/sites/:siteName/experiences/:experienceName', {
                template: '<experience-details>',
            }).
            when('/v1/sites/', {
                template: '<sites-list>',
            }).
            when('/v1/sites/:name', {
                template: '<site-details>',
            }).
            otherwise({
                redirectTo: '/v1/experiences/',
            });
        },
    ]);
}))();
